var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGasmeter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#03A9F4",
    d: "M32.8,12.8c0,0.2-0.8,5.1-3.2,7.2C32.8,9.7,24,4,24,4s-1.4,7.6-4,10.5c-0.2-3.3-2-5.3-2-5.3c-1.4,5.9-6,11-6,14.9c0,6.6,5.4,12,12,12c6.6,0,12-5.399,12-12C36,19.2,34.6,15.7,32.8,12.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#607D8B",
    d: "M13,38h22c2.2,0,4,1.8,4,4v2H9v-2C9,39.8,10.8,38,13,38z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M22 38H26V41H22zM30 38H34V41H30zM14 38H18V41H14z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3E5FC",
    d: "M28,30c0,2.2-1.8,4-4,4s-4-1.8-4-4s4-10,4-10S28,27.8,28,30z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasmeter);
export default __webpack_public_path__ + "static/media/gasmeter.d4d365de2179483aa83cab59d33a676d.svg";
export { ForwardRef as ReactComponent };